import { Select } from "components/Select";
import { QUOTE_FILTER_ALL } from "types/quote/filters";

interface Props {
  onShipmentTypeChange: (value: string) => void;
  shipmentType: string | undefined;
}

const OPTIONS: { value: QuoteShipmentTypeFilterValue; label: string }[] = [
  {
    value: "ALL",
    label: "All",
  },
  {
    value: "MULTI_SHIPMENT_PROJECT",
    label: "Project Shipments",
  },
  {
    value: "SINGLE",
    label: "Single Shipments",
  },
  {
    value: "QUOTES_ONLY",
    label: "Quotes Only Shipments",
  },
];

const DEFAULT_SHIPMENT_TYPE: QuoteShipmentTypeFilterValue = QUOTE_FILTER_ALL;

export function QuoteShipmentTypeFilter(props: Props) {
  const { onShipmentTypeChange, shipmentType } = props;

  return (
    <Select
      inputLabel="Shipment Type"
      defaultValue={DEFAULT_SHIPMENT_TYPE}
      value={shipmentType ?? DEFAULT_SHIPMENT_TYPE}
      onChange={onShipmentTypeChange}
      options={OPTIONS}
      sx={{ minWidth: 0 }}
    />
  );
}
